import { MsalService } from '@azure/msal-angular';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { GlobalConstants } from '../constants/global-constants';

@Injectable()
export class AuthGuard  {

  constructor(private msalService: MsalService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const hasMsalAccount = this.msalService.instance.getAllAccounts().length > 0;
    const hasBypassToken = sessionStorage.getItem(GlobalConstants.bypassTokenStorageKey) !== null;

    if (!hasMsalAccount && !hasBypassToken) {
      // Remembered so HomeComponent can send the user back here after they sign in.
      localStorage.setItem("redirect_url", state.url);
      void this.router.navigate(["/"]);

      // Must be false. Returning true after firing the navigate activated the route
      // anyway, so the page rendered fully signed-in - menu and all - while every data
      // load failed behind it, which is what produced the toast stack in AB#34659.
      return false;
    }

    return true;
  }
}
